import { isNil } from "lodash";

import { Precision } from "../../../types";
import batchUtils from "../../batchUtils";
import { calendarSelectors } from "../../definition/calendar";
import dateFunctions, { javascriptDateToAeonDate } from "../../definition/calendar/dateFunctions";
import { timespanForPrecisionAndUnits } from "../../definition/calendar/dateFunctions/timespanFunctions";

const getNowDateFromAction = (action, calendar) => {
  const actionAppliedJsDate = batchUtils.findActionValue(action, "actionAppliedJsDate");
  if (actionAppliedJsDate || !isNil(calendar.overrideNowTimestamp)) {
    return !isNil(calendar.overrideNowTimestamp)
      ? dateFunctions.dateWithTimestamp(calendar, calendar.overrideNowTimestamp)
      : javascriptDateToAeonDate(calendar, actionAppliedJsDate);
  }
  return null;
};

const getTodayDateFromAction = (action, calendar) => {
  const nowDate = getNowDateFromAction(action, calendar);
  return nowDate
    ? dateFunctions.dateAtEvenSpanBeforeDate(calendar, nowDate, timespanForPrecisionAndUnits(Precision.Day, 1))
    : null;
};

const getTodayDateFromActionOrLastState = (action, globalState) => {
  const calendar = calendarSelectors.getCalendar(globalState);
  const newDate = getTodayDateFromAction(action, calendar);
  if (!newDate) {
    return globalState.display.lastTodayDate;
  }
  return newDate;
};

export default {
  getTodayDateFromActionOrLastState
};
